import { css } from 'styled-components';
export const BKJThemeCheckbox = {
    GreenSolid: {
        unchecked: css `
      background-color: ${({ theme }) => theme.colors.White};
      border: 1px solid ${({ theme }) => theme.colors.Grey6};
    `,
        checked: css `
      background-color: ${({ theme }) => theme.colors.AccentGreen};
      border: 1px solid ${({ theme }) => theme.colors.AccentGreen};
    `,
    },
    PurpleSolid: {
        unchecked: css `
      background-color: ${({ theme }) => theme.colors.White};
      border: 1px solid ${({ theme }) => theme.colors.Grey6};
    `,
        checked: css `
      background-color: ${({ theme }) => theme.colors.PrimaryDefault};
      border: 1px solid ${({ theme }) => theme.colors.PrimaryDefault};
    `,
    },
    GreenNoBorder: {
        unchecked: css `
      background-color: transparent;
      border: 0;
    `,
        checked: css `
      background-color: transparent;
      border: 0;
    `,
    },
    PurpleOutlined: {
        unchecked: css `
      background-color: ${({ theme }) => theme.colors.White};
      border: 1px solid ${({ theme }) => theme.colors.Grey6};
    `,
        checked: css `
      background-color: ${({ theme }) => theme.colors.White};
    `,
    },
};
//# sourceMappingURL=BKJCheckbox.theme.js.map